import Link from "next/link";
import Image from "next/image";

import styled from "styled-components";

import { getOpacityColor, grayScale, pink } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";
import { ellipsis } from "@enkor/design/mixins";

export const EVENT_IMAGE_SIZE = 120;
export const AVATAR_SIZE = 20;

export const EventCard = styled(Link)<{ $isWebview?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  padding: 12px;
  border: 1px solid ${grayScale[300]};
  border-radius: 8px;

  background-color: ${getOpacityColor(grayScale[300], 0.7)};

  cursor: pointer;

  transition: all 0.3s ease-in-out;
  transform: translateY(0);

  &:hover {
    transform: ${({ $isWebview }) =>
      $isWebview ? "none" : "translateY(-3px)"};
  }
`;

export const EventInfoWrapper = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;

  width: 100%;
`;

export const EventImageWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  overflow: hidden;

  width: ${EVENT_IMAGE_SIZE}px;
  height: ${EVENT_IMAGE_SIZE}px;
  border-radius: 8px;
  aspect-ratio: 1/1;
`;

export const EventImage = styled(Image)`
  width: 100%;
  height: 100%;
`;

export const EventInfo = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 8px;
`;

export const EventTitle = styled(Typo.Heading)`
  color: ${grayScale.white};
  font-weight: 700;
`;

export const HostInfo = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const AvatarImageWrapper = styled.div<{ $withBorder?: boolean }>`
  position: relative;
  flex-shrink: 0;
  overflow: hidden;

  width: ${AVATAR_SIZE}px;
  height: ${AVATAR_SIZE}px;
  border: ${({ $withBorder }) =>
    $withBorder ? `1px solid ${grayScale.main}` : "none"};
  border-radius: 50%;
`;

export const HostAvatar = styled(Image)`
  object-fit: cover;

  width: 100%;
  height: 100%;
`;

export const HostName = styled(Typo.Text)`
  color: ${grayScale[700]};

  ${ellipsis(1)}
`;

export const EventDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const EventDetailBox = styled.div`
  display: flex;
  gap: 4px;

  svg {
    flex-shrink: 0;
  }
`;

export const EventDetail = styled(Typo.Text)`
  color: ${grayScale[700]};

  ${ellipsis(1)}
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  margin: 10px 0 8px;

  background-color: ${grayScale.main};
`;

export const AdditionalInfoWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

// 간단한 유저 아바타 리스트를 위한 스타일드 컴포넌트
export const UserAvatars = styled.div<{ $isStrong?: boolean }>`
  display: flex;

  p {
    color: ${({ $isStrong }) =>
      $isStrong ? `${pink.main} !important` : grayScale.white};
  }
`;

export const AttendeeAvatarWrapper = styled(AvatarImageWrapper)`
  margin-left: -4px;

  &:first-child {
    margin-left: 0;
  }
`;

export const Avatar = styled(Image)`
  object-fit: cover;

  width: 100%;
  height: 100%;
`;

export const StatusTag = styled(Typo.Heading)`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;

  padding: 4px 8px;
  border-radius: 4px;

  background-color: ${pink.main};

  color: ${grayScale.white};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;

  transform: translate(-50%, -50%);
`;

export const CloseEventWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background: ${getOpacityColor(grayScale.black, 0.4)};
`;
